<template>
  <MeetingList v-if="canSeeMeetings && hasMeetingsBeforeFiltering" />
  <MeetingListEmpty v-else-if="canSeeMeetings" />
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import MeetingListEmpty from "@/components/meeting/MeetingListEmpty.vue";
import MeetingList from "@/components/meeting/MeetingList.vue";
import { getLSdata } from "@/utils/localStorage";

export default {
  components: {
    MeetingListEmpty,
    MeetingList
  },

  computed: {
    ...mapState("meeting", ["currentMeetingId", "hasMeetingsBeforeFiltering"]),
    ...mapGetters("meeting", ["hasMeetings"]),
    ...mapGetters("profile", ["canSeeBilling", "canSeeMeetings"])
  },

  watch: {
    hasMeetings(value) {
      if (!this.hasMeetingsBeforeFiltering) {
        if (value) {
          this.setHasMeetings();
        }
      }
    }
  },
  methods: {
    ...mapMutations("meeting", ["setHasMeetings"]),
    ...mapActions("billing", ["getBalance"]),
    ...mapActions("meeting", ["getAllMeetings", "getMeetingById"])
  },
  mounted() {
    if (this.canSeeBilling) {
      this.getBalance();
    }
    if (this.canSeeMeetings) {
      this.getAllMeetings();
    }
  }
};
</script>
